import { z } from 'zod'

export const addMappingSchema = z.object({
  structurename: z.string().min(1),
  provider: z.string().min(1),
  is_agent_id: z.boolean(),
  external_id: z.string().min(1),
  from_date: z.string().optional(),
})

export type AddMappingFormType = z.infer<typeof addMappingSchema>
